import type { MaterialOrderRequestColumn } from '../../types/column-types'

export const materialColumns: MaterialOrderRequestColumn[] = [
    {
        dataIndex: ['material'],
        title: 'Материал',
        // @ts-ignore
        children: [
            {
                dataIndex: ['material', 'material_type', 'name'],
                title: 'Тип',
                width: 220,
            },
            {
                dataIndex: ['material', 'width'],
                title: 'Ширина',
                width: 220,
            },
        ],
    },
]
